export const instruments = [
	{ displayName: 'Violin', id: 'violin2' },
	{ displayName: 'Flute', id: 'flute2' },
];

export const evaluationMidi = [
	{
		fileName: 'original.mid',
		displayName: 'Für Elise (naïve method: using midi pitch as pitch and midi velocity as loudness)',
		audioFileName: 'original.mid_naive.wav',
	},
	{ fileName: 'original.mid', displayName: 'Für Elise' },
	{
		fileName: '3:4 duration.mid',
		displayName: 'Für Elise, midi timestretched to 3/4 duration',
		audioFileName: '3:4 duration.mid_generated_performance.wav',
	},
	{ fileName: '5:4 duration.mid', displayName: 'Für Elise, midi timestreched to 5/4 duration' },

	{ fileName: 'transposed down.mid', displayName: 'Für Elise, midi transposed 1 octave down' },
	{ fileName: 'transposed up.mid', displayName: 'Für Elise, midi transposed 1 octave up' },

	{ fileName: 'low vel.mid', displayName: 'Für Elise, lowered midi velocity' },

	{ fileName: 'high vel.mid', displayName: 'Für Elise, hightened midi velocity' },

	{ fileName: 'short notes.mid', displayName: 'Für Elise, shortened midi notes' },

	{ fileName: 'ode_to_joy.mid', displayName: 'Ode to joy' },
];

export const midiFiles = [
	{ fileName: 'original.mid', displayName: 'Für Elise' },
	{
		fileName: '3:4 duration.mid',
		displayName: 'Für Elise, faster',
		audioFileName: '3:4 duration.mid_generated_performance.wav',
	},
	// {
	// 	fileName: 'original.mid',
	// 	displayName: 'Für Elise, with added vibrato',
	// 	audioFileName: 'original.mid_generated_performance_w_vibrato.wav',
	// },
	{ fileName: 'transposed down.mid', displayName: 'Für Elise (1 octave down)' },
	{ fileName: 'transposed up.mid', displayName: 'Für Elise (1 octave up)' },
	{ fileName: 'high vel.mid', displayName: 'Für Elise (high velocity)' },
	{ fileName: 'low vel.mid', displayName: 'Für Elise (low velocity)' },
	{ fileName: 'ode_to_joy.mid', displayName: 'Ode to joy' },
	// {
	// 	fileName: 'ode_to_joy.mid',
	// 	displayName: 'Ode to joy, 8X downsampled performance features to smoothen out artefacts',
	// 	audioFileName: 'ode_to_joy.mid_eighth_resample.wav',
	// },
	// {
	// 	fileName: 'ode_to_joy.mid',
	// 	displayName: 'Ode to joy, with added vibrato',
	// 	audioFileName: 'ode_to_joy.mid_generated_performance_w_vibrato.wav',
	// },

	// { fileName: 'ode_to_joy.mid', displayName: 'ode_to_joy.mid' },

	// { fileName: 'transposed up.mid', displayName: 'transposed up.mid' },
	// { fileName: '5:4 duration.mid', displayName: '5:4 duration.mid' },

	// { fileName: 'very short notes.mid', displayName: 'very short notes.mid' },
	// { fileName: 'fe_increasing_dynamics.mid', displayName: 'fe_increasing_dynamics.mid' },
	// { fileName: '3:4 duration.mid', displayName: '3:4 duration.mid' },
];

export const artefactDemos = [
	{
		title: 'Spontaneous gibberish',
		description:
			'In the beginning of the flute synthesis of Für Elise, we can hear some non musical sounds at the start of the piece even though no note events have yet occured.',
		demos: [{ fileName: 'original.mid', instrumentId: 'flute2' }],
	},

	{
		title: 'Looping artefact',
		description:
			'This artefact can be heard in the violin render of ode to joy. During long notes, it sounds like a section of the note is repeating over and over.',
		demos: [{ fileName: 'ode_to_joy.mid', instrumentId: 'violin2' }],
	},

	{
		title: 'Generally unrealistic timbre',
		description: 'This can be heard in both the violin renders and flute render of multiple pieces',
		demos: [
			{ fileName: 'short notes.mid', instrumentId: 'violin2' },
			{ fileName: 'transposed down.mid', instrumentId: 'violin2' },
			{ fileName: 'low vel.mid', instrumentId: 'violin2' },
			// { fileName: 'short notes.mid', instrumentId: 'flute2' },
			// { fileName: 'transposed down.mid', instrumentId: 'flute2' },
			// { fileName: 'low vel.mid', instrumentId: 'flute2' },
		],
	},

	{
		title: 'Off pitch',
		description:
			'This occurs to varying degrees in all rendered audio. Although this can occur in real performances of novice players of certain continuous pitch instruments like the violin, it does not occur to this extent in performances by advanced players like the ones used to train the model.',
		demos: [{ fileName: 'original.mid', instrumentId: 'flute2' }],
	},

	// {
	// 	title: 'Unrealistic timbre and glissando',
	// 	description:
	// 		'This can be heard in both the violin render and flute render of Für Elise (transposed down). When the instrument is in the lower register it sounds very synthetic. Also, the transitions between the notes does not sound realistic but rather like the note is being pitch shifted between both pitches.',
	// },

	// {
	// 	title: 'Off pitch/Wobbly pitch',
	// 	description:
	// 		'This occurs to varying degrees in all rendered audio. It can be clearly heard in the flute rendition of Für Elise. Although this can occur in real performances of novice players of certain continuous pitch instruments like the violin, it does not occur to this extent in performances by advanced players like the ones used to train the model',
	// },
];

export const vibratoDemos = [
	{
		fileName: 'ode_to_joy.mid',
		displayName: 'Ode to joy, without vibrato',
		audioFileName: 'ode_to_joy.mid_generated_performance.wav',
	},
	{
		fileName: 'ode_to_joy.mid',
		displayName: 'Ode to joy, with vibrato added prior to the synthesis model',
		audioFileName: 'ode_to_joy.mid_generated_performance_w_previbrato.wav',
	},
	{
		fileName: 'ode_to_joy.mid',
		displayName: "Ode to joy, with vibrato added only to the harmonic synthesizer's f0 input",
		audioFileName: 'ode_to_joy.mid_generated_performance_w_postvibrato.wav',
	},
];

export const instrumentIdToDisplayName = (iid) => instruments.find((e) => e.id == iid).displayName;

export const midiFileNameToDisplayName = (iid) => {
	return midiFiles.find((e) => e.fileName == iid).displayName || iid;
};
